const activeImageSettlers = new WeakMap();

export const cancelActiveViewportImageSettlement = activeImage => {
  const settler = activeImage && activeImageSettlers.get(activeImage);
  if (!settler) return false;
  settler.cancel();
  return true;
};

export const settleCompleteActiveViewportImage = ({
  activeImage,
  expectedSource,
  baseUrl,
  settle,
} = {}) => {
  if (!activeImage?.complete || !(activeImage.naturalWidth > 0) || !expectedSource || typeof settle !== 'function') return false;
  let expectedUrl;
  let activeUrl;
  try {
    expectedUrl = new URL(expectedSource, baseUrl).href;
    activeUrl = new URL(activeImage.src, baseUrl).href;
  } catch (_) {
    return false;
  }
  if (activeUrl !== expectedUrl) return false;
  settle(true, activeImage.src);
  return true;
};

export const displayDecodedViewportFrame = ({
  decodedImage,
  activeImage,
  absoluteUrl,
  isCurrent,
  drawPreview,
  onVisible,
  onCancelled,
  onSettled,
} = {}) => {
  if (!decodedImage || !activeImage || !absoluteUrl || typeof isCurrent !== 'function' || !isCurrent()) return false;

  activeImageSettlers.get(activeImage)?.cancel();
  let visiblePublished = false;
  const publishVisible = surface => {
    if (visiblePublished) return true;
    if (!isCurrent()) return false;
    let accepted = true;
    try { accepted = onVisible?.({ surface }) !== false; } catch (_) { accepted = false; }
    if (!accepted) return false;
    visiblePublished = true;
    return true;
  };
  drawPreview?.(decodedImage, {
    beforeReveal: () => publishVisible('preview'),
  });

  if (activeImage.src === absoluteUrl && activeImage.complete && activeImage.naturalWidth > 0) {
    const visible = publishVisible('active-image');
    onSettled?.({ visible });
    return true;
  }

  let settled = false;
  const cleanup = () => {
    activeImage.removeEventListener?.('load', handleLoad);
    activeImage.removeEventListener?.('error', handleError);
    if (activeImageSettlers.get(activeImage)?.cancel === cancel) activeImageSettlers.delete(activeImage);
  };
  const finish = (visible, requireExpectedSource = true) => {
    if (settled) return;
    settled = true;
    cleanup();
    if (!isCurrent() || (requireExpectedSource && activeImage.src !== absoluteUrl)) {
      try { onCancelled?.(); } catch (_) {}
      return;
    }
    const publishedVisible = visible ? publishVisible('active-image') : false;
    onSettled?.({ visible: publishedVisible });
  };
  const cancel = () => {
    if (settled) return;
    settled = true;
    cleanup();
    try { onCancelled?.(); } catch (_) {}
  };
  const handleLoad = () => finish(true);
  const handleError = () => finish(false);

  activeImageSettlers.set(activeImage, { cancel });
  activeImage.addEventListener?.('load', handleLoad);
  activeImage.addEventListener?.('error', handleError);
  try {
    activeImage.src = absoluteUrl;
  } catch (_) {
    finish(false, false);
    return false;
  }
  return true;
};
